module.exports = [
        {
            "category": "Physiotherapy",
            "intent": "dr_services",
            "entity_key": "dr_physio_entity",
            "entity_value": "physiotherapy"
        },
        {
            "category": "Rehabilitation",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "rehabilitation"
        },
        {
            "category": "Wellbeing",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "wellbeing"
        },
        {
            "category": "Acupuncture",
            "intent": "dr_services",
            "entity_key": "dr_physio_entity",
            "entity_value": "acupuncture"
        },
        {
            "category": "Pelvic Health",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "pelvic_health"
        },
        {
            "category": "Psychology",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "psychology"
        },
        {
            "category": "Concussion",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "concussion"
        },
        {
            "category": "Occupational Assessment",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "occupational_assessment"
        },
        {
            "category": "Nutrition",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "nutrition"
        },
        {
            "category": "Speech & Language Therapy",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "speech_and_language "
        },
        {
            "category": "Workshops",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "workshops"
        },
        {
            "category": "Sports",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "sports"
        },
        {
            "category": "ACC & WINZ Services",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "acc_winz_services"
        },
        {
            "category": "Exercise & Training",
            "intent": "dr_services",
            "entity_key": "dr_general_entity",
            "entity_value": "exercise_and_training"
        },
        {
            "category": "Dental Exam & X-Rays",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "exam_and_xray"
        },
        {
            "category": "Dental Crowns & Bridges",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "crowns_and_bridges"
        },
        {
            "category": "Braces & Invisalign",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "braces_and_invisalign"
        },

        {
            "category": "Dentures",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "dentures"
        },
        {
            "category": "Teeth Extraction",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "teeth_extraction"
        },
        {
            "category": "Mouth Guards",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "mouth_guards"
        },
        {
            "category": "Dentofacial",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "dentofacial"
        },
        {
            "category": "Dental Implants",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "dental_implants"
        },
        {
            "category": "Dental Hygiene",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "dental_hygiene"
        },
        {
            "category": "Root Canal",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "root_canal"
        },
        {
            "category": "Tooth Whitening",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "tooth_whitening"
        },
        {
            "category": "Kids Dental",
            "intent": "dr_services",
            "entity_key": "dr_dentist_entity",
            "entity_value": "kids_dental"
        }
]
